import { makeContactRepository } from './features/contacts/repository';
import { makeRevealContactRepository } from './features/contacts/revealContact/repository';
import { makeRevealContactsBulkUseCase, makeRevealContactUseCase } from './features/contacts/revealContact/useCase';
import { makeExportAccountToCrmRepository } from './features/crm/exportAccountToCrm/repository';
import { makeExportAccountToCrmUseCase } from './features/crm/exportAccountToCrm/useCase';
import { makeExportContactsToCrmRepository } from './features/crm/exportContactsToCrm/repository';
import { makeExportContactsToCrmUseCase } from './features/crm/exportContactsToCrm/useCase';
import { makeSaveDomainToListRepository } from './features/opportunityLists/saveDomainToList/repository';
import { makeSaveDomainToListUseCase } from './features/opportunityLists/saveDomainToList/useCase';
import { makeCreatePersonaRepository } from './features/persona/createPersona/repository';
import { makeCreatePersonaUseCase } from './features/persona/createPersona/useCase';
import { makeDeletePersonaRepository } from './features/persona/deletePersona/repository';
import { makeDeletePersonaUseCase } from './features/persona/deletePersona/useCase';
import { makeUpdatePersonaRepository } from './features/persona/updatePersona/repository';
import { makeUpdatePersonaUseCase } from './features/persona/updatePersona/useCase';
import { makeNotifyAdminUseCase } from './features/quota/notifyAdmin/useCase';
import { makeQuotaRepository } from './features/quota/repository';
import { makeUserRepository } from './features/user/repository';
import { queryClient } from './queryClient';
import { appStore } from './services/appStore';
import type { UseCaseContainer } from './UseCaseProvider';

export function initUseCases(): UseCaseContainer {
  const userRepository = makeUserRepository(queryClient);
  const quotaRepository = makeQuotaRepository(queryClient, { userRepository });
  const contactRepository = makeContactRepository(queryClient);
  const revealContactRepository = makeRevealContactRepository(contactRepository);

  const createPersonaRepository = makeCreatePersonaRepository(appStore, queryClient);
  const updatePersonaRepository = makeUpdatePersonaRepository(appStore, queryClient);
  const deletePersonaRepository = makeDeletePersonaRepository(appStore, queryClient);

  const exportContactsToCrmRepository = makeExportContactsToCrmRepository(appStore, contactRepository, quotaRepository);
  const exportAccountToCrmRepository = makeExportAccountToCrmRepository(appStore, quotaRepository);

  const saveDomainToListRepository = makeSaveDomainToListRepository(appStore);

  return {
    revealContact: makeRevealContactUseCase({
      contactRepository: revealContactRepository,
      userRepository,
      quotaRepository,
    }),
    revealContactsBulk: makeRevealContactsBulkUseCase({
      contactRepository: revealContactRepository,
      userRepository,
      quotaRepository,
    }),
    createPersona: makeCreatePersonaUseCase(createPersonaRepository),
    updatePersona: makeUpdatePersonaUseCase(updatePersonaRepository),
    deletePersona: makeDeletePersonaUseCase(deletePersonaRepository),
    exportContactsToCrm: makeExportContactsToCrmUseCase(exportContactsToCrmRepository),
    exportAccountToCrm: makeExportAccountToCrmUseCase(exportAccountToCrmRepository),
    saveDomainToList: makeSaveDomainToListUseCase(saveDomainToListRepository),
    notifyAdmin: makeNotifyAdminUseCase(quotaRepository),
  };
}
